<form [formGroup]="form" class="preference-form">
  <div class="row">
    <!-- <div class="col-sm-4">
      <mat-checkbox
        matTooltip="Allow this House Staff to see guest name"
        matTooltipClass="text-center"
        matTooltipPosition="above"
        formControlName="guest_name"
      >
        Show Guest Name
      </mat-checkbox>
    </div> -->
    <div class="col-sm-4">
      <mat-checkbox
        matTooltip="Allow this House Staff to see guest email"
        i18n-matTooltip
        matTooltipClass="text-center"
        matTooltipPosition="above"
        formControlName="guest_email"
        i18n
      >
        Show Guest Email
      </mat-checkbox>
    </div>
    <div class="col-sm-4">
      <mat-checkbox
        matTooltip="Allow this House Staff to see guest phone"
        i18n-matTooltip
        matTooltipClass="text-center"
        matTooltipPosition="above"
        formControlName="guest_phone"
        i18n
      >
        Show Guest Phone
      </mat-checkbox>
    </div>
  </div>
</form>
